import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getDetail } from './api'; // Importation de la fonction asynchrone
import { Report } from './type';

const useGetDetail = (report: Report | null) => {
    return useQuery<Array<Report>, AxiosError>({
        queryKey: ['detail', `${report?.date}-${report?.reunion}-${report?.course}`],
        queryFn: () => getDetail(report?.date, report?.reunion, report?.course),
        enabled: !!report && report !== null,
        staleTime: 1000 * 60 * 10,
        retry: (failureCount, error) => error.response?.status !== 404,
        refetchOnWindowFocus: false,
    });
};

export default useGetDetail;
